const $$splitComponentImporter = () => import('/app/src/routes/meetings_.$meetingId.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/meetings_/$meetingId')({
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr)
});